"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _UpoCloud = /*#__PURE__*/ _interop_require_default(require("./UpoCloud"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let UpCloudPlugin = class UpCloudPlugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return UpCloudPlugin.storageAdapter;
    }
    async init(config) {
        UpCloudPlugin.storageAdapter = new _UpoCloud.default(config);
        await UpCloudPlugin.storageAdapter.init();
    }
};
const _default = UpCloudPlugin;
